<h2>{{infoTitle}}</h2>
<div class="right-margin">
    <button class="close-icon" (click)="closeDialog()"><div class="line1"><div class="line2"></div></div></button>
</div>
<div class="body form">
    <div class="max-height" [innerHTML]="infoMessage"></div>
</div>